<template>
  <div>
    <div>
      <b-card>
        <b-form @submit.prevent>
          <validation-observer ref="PostValidation">
            <b-row>
              <b-col md="12" class="mb-1 text-center">
                <div v-if="url">
                  <img :src="url" width="50%" class="img-fluid" />
                </div>
                <div v-else>
                  <video v-if="form.media === 'video'" width="50%" controls>
                    <source
                      :src="appUrl + '/' + form.media_path"
                      type="video/mp4"
                    />
                  </video>
                  <img
                    v-else
                    :src="appUrl + '/' + form.media_path"
                    width="50%"
                    class="img-fluid"
                  />
                </div>
              </b-col>

              <b-col md="12" class="mb-1">
                <b-form-group label="Post Title">
                  <validation-Provider
                    name="Post Title"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-input v-model="form.title"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-Provider>
                </b-form-group>
              </b-col>

              <b-col md="12" class="mb-1">
                <b-form-group label="Change Media (Optional)">
                  <b-form-file
                    v-model="file"
                    @change="previewImage"
                    placeholder="Select new file to replace..."
                  ></b-form-file>
                </b-form-group>
              </b-col>

              <b-col md="12" class="mb-1 text-center">
                <b-button
                  variant="primary"
                  @click="updatePost()"
                  block
                  type="submit"
                >
                  Update Post
                </b-button>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BCol,
  BRow,
  BFormFile,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
import postApi from "@/Api/Modules/posts";
import { $themeConfig } from "@themeConfig";

export default {
  name: "UpdatePost",
  components: {
    BCard,
    BFormFile,
    BForm,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BButton,
    BCol,
    BRow,
  },
  data() {
    return {
      form: {},
      file: null,
      url: null, // For previewing new image selection
    };
  },
  props: {
    updatingdata: Object,
  },
  created() {
    this.initializeData();
  },
  setup() {
    const { appUrl } = $themeConfig.app;
    return {
      appUrl,
    };
  },
  methods: {
    previewImage(event) {
      // Basic preview for images.
      // Note: Video preview from local file input is complex, we just show file name usually.
      const file = event.target.files[0];
      if (file && file.type.includes("image")) {
        this.url = URL.createObjectURL(file);
      } else {
        this.url = null; // Don't preview video as image
      }
      this.file = file;
    },

    initializeData() {
      // Clone the object to avoid mutating prop directly
      this.form = { ...this.updatingdata };
    },

    async updatePost() {
      if (await this.$refs.PostValidation.validate()) {
        await this.$vs.loading({
          scale: 0.8,
        });

        let form = new FormData();
        form.append("id", this.form.id);
        form.append("title", this.form.title);

        // Only append file if user selected a new one
        if (this.file) {
          form.append("file", this.file);
        }

        await postApi
          .UpdatePost(form)
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
  },
};
</script>
